<div class="dlr-page">
  <header class="dlr-hero">
    <h1>Lokationer og lokaler</h1>
    <p class="dlr-lead">
      Administrer lokationer og lokaler. Foreslåede lokationer (fra brugeres
      roller) kan oprettes, når de findes. Sletning er blokeret, når et lokale
      bruges på en begivenhed, eller når en lokation har lokaler med tilknyttede
      begivenheder.
    </p>
    <div class="dlr-hero-actions">
      @if (suggestedCount > 0) {
      <button
        mat-raised-button
        color="warn"
        type="button"
        class="dlr-suggested-btn"
        (click)="openSuggestedModal()"
      >
        <mat-icon>lightbulb</mat-icon>
        Foreslåede lokationer
        <span class="dlr-badge">{{ suggestedCount }}</span>
      </button>
      }
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="newLocation()"
      >
        <mat-icon>add_location_alt</mat-icon>
        Ny lokation
      </button>
      <button
        mat-raised-button
        color="accent"
        type="button"
        (click)="newRoom()"
      >
        <mat-icon>meeting_room</mat-icon>
        Nyt lokale
      </button>
    </div>
  </header>

  <mat-card class="dlr-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Lokationer</mat-card-title>
      <mat-card-subtitle>Oversigt med nøgletal og handlinger</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-dynamic-table
        #locationsTable
        [dynamicInput]="locationsDynamicInput"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>

  <mat-card class="dlr-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Lokaler</mat-card-title>
      <mat-card-subtitle>Alle lokaler på tværs af lokationer</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-dynamic-table
        #roomsTable
        [dynamicInput]="roomsDynamicInput"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>
</div>
